<template>
  <modal @cancel="cancel" :closeHidden="true">
    <div class="move-group-container " slot="content">
      <div class="move-group-header">{{title}}</div>
      <div class="move-group-content" ref="scroll_container">
        <ul>
          <li v-for="group in groupList.filter(item=>item.id===groupId)"
              @click="selectGroup(group)"
              :key="group.id"
              :class="{default:group==selectedGroup}">
            <span v-text="group.name"></span>
            <span class="checked-tip" v-if="group.IsDefault && enabled">当前所在组</span>
          </li>
          <li class="add-code" v-show="showAddGroup" ref="add_code">
            <el-input placeholder="请输入分组名称" ref="inputRef" size="mini" v-model="newGroup"/>
            <i class="el-icon-circle-close" @click="showAddGroup=false"></i>
            <i class="el-icon-success" @click="saveNewGroup"></i>
          </li>
        </ul>
      </div>
      <div class="move-group-footer">
        <div class="btn-group">
          <el-button  type="primary" :disabled="!selectedGroup" @click="save">确定</el-button>
          <el-button @click="cancel">取消</el-button>
        </div>
      </div>
    </div>
  </modal>
</template>

<script>
  import {Message, Modal} from "@maidi/libs.pc";
  import {WorkflowProcess} from "../workflow";
  import { UtilService } from '@maidi/common';

  export default {
    name: "move-group",
    components: {Modal},
    props: {
      id: {
        type: [Number, String],
        default: 0
      },
      groupId: {
        type: [Number, String],
        default: 0
      },
      name: {
        type: [Number, String],
        default: ""
      },
      enabled: {
        type: [Number, String],
        default: ""
      }
    },
    data() {
      return {
        groupList: [],
        selectedGroup: "",
        newGroup: "",
        showAddGroup: false,
        title: this.enabled?`将"${this.name}"移动到`:`启用"${this.name}"`
      }
    },
    created() {
      this.getGroupList();
    },
    methods: {
      async getGroupList() {
        const res = await WorkflowProcess.groupList();
        if(res.length) this.groupList = res;
        const defaultCode = this.groupList.find(item => item.id == this.groupId);
        if (defaultCode)  defaultCode.IsDefault = true;
      },
      cancel() {
        this.$emit("cancel");
      },
      selectGroup(group){
        if(group.IsDefault && this.enabled) return;
        this.selectedGroup = group;
      },
      async saveNewGroup() {
        if (!this.newGroup) return Message.warn("分组名称不能为空哦~");
        await WorkflowProcess.addGroup({name:this.newGroup});
        await this.getGroupList()
        this.newGroup = "";
        this.showAddGroup = false;
        Message.success('新建分组成功');
      },
      // async showAddCodeHandler() {
      //   this.showAddGroup = true;
      //   await this.$nextTick();
      //   this.$refs.inputRef.focus();
      //   const container = this.$refs.scroll_container;
      //   const addCodeLi = this.$refs.add_code;
      //   const codeLiTop = addCodeLi.offsetTop;
      //   container.scrollTop = codeLiTop;
      // },
      async save() {
        let params = {"id": this.id, "groupId": this.selectedGroup.id }
        if(!params.groupId){
          await WorkflowProcess.disable(params.id)
          Message.success('停用成功!')
        }else if(!this.enabled){
          await WorkflowProcess.enable(params.id)
          Message.success('启用成功!')
        }else {
          await WorkflowProcess.save(params);
          Message.success('移动成功!')
        }

        this.$emit("confirm");
        setTimeout(() => {
          this.cancel();
        }, 300)
      }
    },
  }
</script>

<style scoped lang="scss">
  @import "../../../../assets/css/global";

  .move-group-container {
    font-size: 1.6rem;
    color: $color-font-deep;
    width: 520px;
    .move-group-header {
      height: 46px;
      line-height: 46px;
      border-bottom: 1px dashed #e4e4e4;
      margin: 0 20px;
    }
    .move-group-content {
      height: 220px;
      overflow: scroll;
      li {
        font-size: 1.4rem;
        height: 46px;
        line-height: 46px;
        border-bottom: 1px solid #E4E4E4;
        padding: 0 20px;
        .checked-tip {
          float: right;
          font-size: 1.2rem;
          color: #B2B2B2;
          background: rgba(178, 178, 178, .15);
          margin: 13px 0;
          height: 19px;
          line-height: 19px;
          text-align: center;
          border-radius: 4px;
        }
        &:not(.add-code):hover {
          background: rgba(235, 247, 255, .4);
        }
        &.default {
          background: #EBF7FF;
        }
        &.add-code {
          display: flex;
          align-items: center;
          .el-input {
            width: 202px;
            /deep/ .el-input__inner {
              height: 29px;
              line-height: 29px;
              font-size: 1.4rem;
              padding: 0 8px;
              color: $color-font-deep;
            }
            margin-right: 5px;
          }
          i {
            color: #38adff;
            font-size: 2rem;
            margin-left: 10px;
            cursor: pointer;
            &:first-of-type:hover {
              color: #f60;
            }
            &:last-of-type:hover {
              color: #3e8acc;
            }
          }
        }
      }
    }
    .move-group-footer {
      height: 60px;
      display: flex;
      align-items: center;
      padding: 0 20px;
      .btn-group {
        width: 100%;
        display: flex;
        justify-content: flex-end;
        .el-button {
          height: 36px;
          padding: 0 20px;
          line-height: 36px;
          min-width: 128px;

        }
      }

    }
  }

</style>
